var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H21V6C21 5.45 20.55 5 20 5C19.45 5 19 5.45 19 6V7H11V6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6V7H8C6.89 7 6.01 7.9 6.01 9L6 23C6 24.1 6.89 25 8 25H22C23.1 25 24 24.1 24 23V9C24 7.9 23.1 7 22 7ZM21 23H9C8.45 23 8 22.55 8 22V12H22V22C22 22.55 21.55 23 21 23ZM11 14H14C14.55 14 15 14.45 15 15V18C15 18.55 14.55 19 14 19H11C10.45 19 10 18.55 10 18V15C10 14.45 10.45 14 11 14Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVisits);
export default __webpack_public_path__ + "static/media/MyVisits.1b0b445f01e5e1ef42f06291a9e394cf.svg";
export { ForwardRef as ReactComponent };